import { ElementType } from '@fiverr-private/bianka_js';
import { reportBiEvent } from './reportBiEvent';
import { BiEventData, ReportBiEventParams } from './reportBiEvent.types';

export const reportAiDeliveryBadgeHoverEvent = (biEventData: BiEventData | undefined) => {
    const reportParams: ReportBiEventParams = {
        biEventData,
        activityType: 'hover',
        eventType: 'hovered_offers_ai_badge',
        elementName: 'offers_ai_badge',
        elementType: ElementType.UNSPECIFIED,
    };

    reportBiEvent(reportParams);
};
